import React from 'react';
import SignatureCanvas, { ReactSignatureCanvasProps } from 'react-signature-canvas';
import { Flex, FlexProps } from '@mantine/core';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';
import { useSignaturePad } from '@dealstack/frontend/shared/components/Signature/SignaturePad/useSignaturePad';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props extends FlexProps {
	controller: ReturnType<typeof useSignaturePad>;
	signatureCanvasProps?: ReactSignatureCanvasProps;
}

export const SignaturePad = ({ controller, signatureCanvasProps, ...flexProps }: Props) => {
	const { sigCanvasRef, handleStrokeEnd } = controller;

	return (
		<Flex
			direction="column"
			align="center"
			gap="1rem"
			bg={defaultTheme.v3.colors.white[0]}
			data-testid={TEST_ELEMENT_IDS.EID_EASY_SIGNATURE_PAD}
			{...flexProps}
		>
			<SignatureCanvas
				{...signatureCanvasProps}
				penColor="black"
				canvasProps={{
					...(signatureCanvasProps?.canvasProps || {}),
					style: {
						...(signatureCanvasProps?.canvasProps?.style || {}),
						borderRadius: '0.5rem',
						border: `1px dashed ${defaultTheme.v3.colors.black[0]}`,
						width: '100%',
					},
				}}
				onEnd={(event) => {
					signatureCanvasProps?.onEnd?.(event);
					handleStrokeEnd();
				}}
				ref={sigCanvasRef}
			/>
		</Flex>
	);
};
